export default __webpack_public_path__ + "static/media/maddienbrett.f9c870b1.png";